'use strict';

import { latLngAltToVector3, Layer } from './Layer';
import { BufferGeometry, CatmullRomCurve3, LinearSRGBColorSpace, Color } from 'three';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { Line2 } from 'three/examples/jsm/lines/Line2';
import { EnvironmentLayer } from '../Environment/EnvironmentLayers/EnvironmentLayer';
// import { settingsData, threeJsVariables } from '../../../settings';
// import {
//     addBuildingsIntersections,
//     addPoiToIntersection,
//     isBuildingIntersectionsSet,
//     poiIntersection, removePoiFromIntersection,
// } from '../../poi/poiCss';
// import { getCurrentLang } from '../langSwitcher/langSwitcher';
// import { SelectedObjectType } from '../../../common';
// import { PublicLayers } from './PublicLayers';
// import { RoadsAdditionalEffect } from '../Environment/EnvironmentLayers/RoadsEnvironment';

export class Highway extends Layer {

    constructor (parent, data) {
        super(parent, data);

        this.createLayer();
        // this.roadsEffect = new RoadsAdditionalEffect();
        this.animateCamera = true;
    }

    show() {
        super.show();
        EnvironmentLayer.animateCameraShow();
    }

    hide() {
        super.hide();
        EnvironmentLayer.animateCameraHide();
    }

    async createLayer() {

        this.data = await this.response;

        if (!this.data) {
            this.btn?.remove();
            return ;
        }

        const center = {lat: Number(config.localization.latitude), lng: Number(config.localization.longitude)};

        this.data.forEach(el => {
            const points = [];
            const names = {};
            config.languages.forEach(lang => {
                if (el.tags.hasOwnProperty(`name:${lang}`)) {
                    names[lang] = el.tags[`name:${lang}`];
                } else if (el.tags.hasOwnProperty('name')) {
                    names[lang] = config.dictionary[el.tags.name] ? config.dictionary[el.tags.name][lang] : el.tags.name;
                }
            });

            el.geometry.forEach(coords => {

                const point = {lat: coords.lat, lng: coords.lon};
                const vector = latLngAltToVector3(point,center);

                if (coords.elevation) {
                    vector.y = coords.elevation;
                }

                points.push(vector);

            });

            // const curve = new CatmullRomCurve3(points);
            // curve.curveType = 'centripetal';
            // curve.tension = 0.5;
            // const curvedPoint = curve.getPoints(10);
            const geometry = new BufferGeometry().setFromPoints(points);
            const lineGeometry = new LineGeometry().setPositions(geometry.getAttribute('position').array);
            let lineWidth = 0;

            if (el.tags.highway === 'motorway') {
                lineWidth = 6;
            } else {
                lineWidth = 5;
            }

            const lineMaterial = new LineMaterial({
                color: new Color().setStyle(this.layer.colors[el.tags.highway] || '#ffd000',LinearSRGBColorSpace),
                linewidth: lineWidth,
                dashed: false,
                opacity: 0.9,
                alphaToCoverage: true
            });

            lineMaterial.resolution.set( window.innerWidth / 4, window.innerHeight / 4 );
            let line = new Line2(lineGeometry,lineMaterial);
            line.name = 'route';
            line.userData.type = 'route';
            line.userData.routeData = {};

            if (Object.keys(names).length) {
                line.userData.routeData.name = names;
            }

            line.computeLineDistances();
            line.scale.set(1,1,1);

            const dashMaterial = new LineMaterial({
                color: new Color().setStyle(this.layer.colors.dash,LinearSRGBColorSpace),
                linewidth: lineWidth,
                dashed: true,
                dashOffset: 1,
                opacity: 0.6,
                gapSize: 20,
                dashSize: 10,
                alphaToCoverage: true
            });

            dashMaterial.resolution.set( window.innerWidth / 4, window.innerHeight / 4 );

            const dashLine = new Line2(lineGeometry,dashMaterial);
            dashLine.computeLineDistances();
            dashLine.scale.set(1,1,1);

            const direction = this.layer.direction === 'counterclockwise' ? -1 : 1;


            dashMaterial.tick = () => {
                dashMaterial.dashOffset += direction;
            };

            this.animations.push(dashMaterial);

            this.routeGroup.add(line);
            this.routeGroup.add(dashLine);
        });
    }
    
    // show() {
    //     if (this.active) return;
    //
    //     this.roadsEffect.enable().then(() => {
    //         threeJsVariables.scene.add(this.routeGroup);
    //         threeJsVariables.renderList.reorder();
    //     });
    //
    //     !isBuildingIntersectionsSet() && addBuildingsIntersections();
    //
    //     this.routeGroup.traverse(el => {
    //         if (el.type === 'Object3D' && el.name.startsWith('layer-poi')) {
    //             const text = el.element.querySelector('.public-label__text') || el.element.querySelector('.public-label__name') ;
    //             if (text) {
    //                 text.innerText = text.getAttribute(`data-lang-${getCurrentLang()}`);
    //             }
    //             addPoiToIntersection(el);
    //             poiIntersection();
    //         } else if (el.isMesh && el.userData.type === SelectedObjectType.Route) {
    //             settingsData.objects_to_intersection.push(el);
    //         }
    //     });
    //
    //
    //     this.active = true;
    //     this.enable();
    // }
    //
    // hide() {
    //     this.roadsEffect.disable();
    //     this.routeGroup.removeFromParent();
    //
    //     this.routeGroup.traverse(el => {
    //         if (!el.isGroup) {
    //
    //             if (el.type === 'Object3D' && el.name.startsWith('layer-poi')){
    //                 el.element.remove();
    //                 removePoiFromIntersection(el);
    //             } else {
    //                 el.geometry.dispose();
    //                 el.material.dispose();
    //                 settingsData.objects_to_intersection = settingsData.objects_to_intersection.filter(intersectedObject => intersectedObject !== el);
    //             }
    //         }
    //     });
    //     this.animations = this.animations.filter(material => material.name !== 'route_dash');
    //     this.removeRoute();
    //     this.active = false;
    //     this.disable();
    //     PublicLayers.scope.hidePopup();
    // }

}
